import withComponent from "../../hoc/withComponent";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components"
import FlexStyled from "../../styled/FlexStyled"
import config from "./config";

const TabItemStyled = styled.div`
  display: inline-block;
  height: 28px;
  padding: 0 14px;
  border-radius: 4px;
  line-height: 28px;
  margin: 11px 0;
  margin-right: 20px;
  box-sizing: border-box;
  white-space: nowrap;

  font-size: 16px;
  font-family: PingFangSC-Medium, "PingFang SC";
  font-weight: 500;
  color: #000000;
  cursor: pointer;

  ${props => props.$isActive ? '    background: #11BBA6;\n    color: #FFFFFF;' : ''}
  &:hover {
    background: #11BBA6;
    color: #FFFFFF;
  }
`
const TabItemTextStyled = styled.div`
  display: inline-block;
  height: 50px;
  /* padding: 4px 0px; */
  border-radius: 4px;
  line-height: 50px;

  font-size: 16px;
  font-family: PingFangSC-Medium, "PingFang SC";
  font-weight: 400;
  color: #000000;
`
const TabContainerStyled = styled.div`
  padding: 30px 0;
  background: #FFFFFF;
  box-shadow: 2px 5px 12px -2px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  user-select: none;
`
const TabMoreContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 26px;
  cursor: pointer;
`

const GroupContainerStyled = styled.div`
  display: flex;
`
const GroupTitleStyled = styled.div`
  width: 82px;
  height: 50px;
  line-height: 50px;
  flex-shrink: 0;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #000000;
  display: inline-block;
  text-align: center;
  margin-left: 6px;
`
const GroupTagsContainerStyled = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  flex-grow: 1;
  padding-right: 70px;
  overflow: hidden;
`


const icon1 = <div style={{ height: 8, width: 8, position: "relative" }} dangerouslySetInnerHTML={{
    __html: `<svg
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        width='8'
        height='8'
        fill='rgb(153,153,153)'
                style="position: absolute;top: 0;"

    >
        <path
            d='M573.056 272l308.8 404.608A76.8 76.8 0 0 1 820.736 800H203.232a76.8 76.8 0 0 1-61.056-123.392L450.976 272a76.8 76.8 0 0 1 122.08 0z'
            p-id='3015'
        ></path>
    </svg>`
}} />
const icon2 = <div style={{ height: 8, width: 8, position: "relative" }} dangerouslySetInnerHTML={{
    __html: `<svg
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        width='8'
        height='8'
        fill='rgb(153,153,153)'
        style="position: absolute;top: 0;"
    >
        <path
            d='M573.056 752l308.8-404.608A76.8 76.8 0 0 0 820.736 224H203.232a76.8 76.8 0 0 0-61.056 123  .392l308.8 404.608a76.8 76.8 0 0 0 122.08 0z'
            p-id='2102'
        ></path>
    </svg>`
}} />


const Group = (props) => {
    const { activeIndex = 0, title, children = [], onClick } = props;
    const ref = useRef();
    const [hasMore, setHasMore] = useState(false);
    const [moreVisible, setMoreVisible] = useState(false);
    const onClickMore = () => {
        setMoreVisible((state) => !state)
    }

    useEffect(() => {
        const dom = ref.current;
        let width = 0;
        [...dom.children].forEach((child) => {
            width += child.offsetWidth;
        });
        if (width > ref.current.offsetWidth) {
            setHasMore(true)
        }
    }, []);
    return <GroupContainerStyled>
        <GroupTitleStyled>{title}：</GroupTitleStyled>
        <GroupTagsContainerStyled ref={ref} style={{ height: moreVisible ? undefined : 50 }}>
            {
                children.map((text, index) => {
                    return <TabItemStyled key={text} $isActive={activeIndex === index}
                        onClick={() => onClick(index)}
                    >{text}</TabItemStyled>
                })
            }
            {
                hasMore && <TabMoreContainerStyled onClick={onClickMore}>
                    <TabItemTextStyled style={{ marginRight: 3 }}>更多</TabItemTextStyled>
                    <div>{moreVisible ? icon1 : icon2}</div>
                </TabMoreContainerStyled>
            }
        </GroupTagsContainerStyled>
    </GroupContainerStyled>
}















export default withComponent((props) => {
    const { changeFilterCurrent, filterCurrent, width } = props;
    return <FlexStyled $justifyContent="center">
        <TabContainerStyled style={{ width }}>
            {
                config.map((item, groupIndex) => {
                    return <Group key={item.title}
                        changeFilterCurrent={changeFilterCurrent}
                        title={item.title}
                        activeIndex={filterCurrent[groupIndex]}
                        onClick={(index) => changeFilterCurrent(groupIndex, index)}
                        children={item.children} />
                })
            }
        </TabContainerStyled>
    </FlexStyled>
});
